var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Heading from '@marketing/components/global/typography/Heading';
import FlexSection from '@marketing/components/sections/FlexSection';
import useTicker from '@marketing/useTicker';
import { clsx } from 'clsx';
import Carousel from './Carousel';
function VideoCarouselSection(_a) {
    var content = _a.content, _b = _a.backgroundColorStyle, backgroundColorStyle = _b === void 0 ? 'bg-surface-beige' : _b, _c = _a.theme, theme = _c === void 0 ? 'dark' : _c;
    var videos = content.videos, tickerText = content.tickerText, headline = content.headline, subheading = content.subheading;
    var textStyle = theme === 'light' ? 'text-text-body' : 'text-white';
    return useTicker(_jsxs(FlexSection, __assign({ paddingStyle: "px-2xs-gutter py-xl-m md:pl-0 md:px-2xl-gutter md:py-xl-gutter", className: "items-center md:!justify-between !flex-col-reverse md:!flex-row !overflow-visible", gapStyle: "gap-xl-m", backgroundColorStyle: backgroundColorStyle }, { children: [_jsx("div", __assign({ className: "md:pl-2xl-gutter shrink-0 overflow-hidden" }, { children: _jsx(Carousel, { videos: videos, theme: theme }) })), _jsxs("div", __assign({ className: clsx('flex flex-col shrink-0 gap-xl-m md:w-[380px]', textStyle) }, { children: [_jsx(Heading, __assign({ size: "lg", className: "md:text-left" }, { children: headline })), _jsx("p", { children: subheading })] }))] })), tickerText, backgroundColorStyle, theme);
}
export default VideoCarouselSection;
